<template>
  <div class="text-sm">
    <p class="mt-6"><b>2025.01.18</b> - Обновление системы чата</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Чат
        <ul>
          <li>
            - Вместо одного глобального канала чата... чат-комнаты теперь
            разделены по языку, а также ограничены 200 игроками в каждой.
          </li>
          <li>
            - Введены три новые команды чата:
            <code>/mute &lt;player&gt;</code>, <code>/unmute &lt;player&gt;</code>, и
            <code>/muted</code> (для получения списка заглушённых игроков).
          </li>
          <li>- Вы больше не можете вставлять HTML в чат :)</li>
          <li>
            - Размещение ссылок в чате теперь запрещено, за исключением белого списка. Напишите rob-wfs
            в Discord, если хотите добавить что-то в белый список.
          </li>
        </ul>
      </li>
      <li>
        ИИ
        <ul>
          <li>
            - Призыв дворфа теперь нацелится на клетки рядом с ближайшим врагом, а не рядом с
            заклинателем.
          </li>
          <li>- Юниты Support больше не должны посылать ману призванным юнитам.</li>
          <li>
            - Отряды Пещеры теперь будут баффаться и призывать, пока комнаты пусты, вместо
            бездействия.
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
